<template>
  <div class="bounty_activity">
      <div class="top_blank"></div>
      <div class="top">
          <span class="back" @click="goBack"><i></i></span>
          <div class="title">赏金挑战</div>
          <span class="show_popup" @click="showPopup">赏金攻略</span>
      </div>

      <div class="header">

        <div class="header_step">
          <div class="header_step_item"><span>1</span>试玩小游戏></div>
          <div class="header_step_item"><span>2</span>领取成绩></div>
          <div class="header_step_item"><span>3</span>达到分数></div>
          <div class="header_step_item"><span>4</span>获得赏金</div>
        </div>
        <div class="game_info">
            <div class="game_icon"><img :src="gameIcon"/></div>
            <div class="game_title">{{gameName}}</div>
            <div class="game_money">总奖励：{{totalCoin}}金币 / 已领取：{{receiveCoin}}金币</div>
        </div>
        <div class="kefu" @click="goKefu">联系客服</div>
      </div>
      <div class="main_box">
        <div class="max_score">
          <span class="max_score_txt">当前最高：{{integralShow}}</span>
        </div>
        <div class="ranking_title">
          <span>目标分数</span>
          <span>奖励赏金</span>
        </div>
        <div class="ranking_list">


            <div class="ranging_item" v-for="(item, key) in list" :key=key  :class="getClass(item.status)" @click="toGame">
                <div class="ranging_item_left">
                    <span class="ranging_icon"></span>
                    <span class="ranging_score">{{item.target_txt}}</span>
                </div>
                <div class="ranging_item_right">
                    <span class="ranging_btn" v-if="item.status == 1" @click.stop="receive(item.status, item.reward_code)">待领取</span>
                    <span class="ranging_btn" v-if="item.status == 2">点击领取</span>
                    <span class="ranging_btn" v-if="item.status == 3">已领取</span>
                    <div class="ranging_add">
                        <span class="ranging_add_coin">+{{item.reward}}</span>
                        <span class="ranging_add_icon"></span>
                    </div>
                </div>
            </div>

              <div class="ranging_more">
                <span>更多赏金和挑战即将开放...</span>
              </div>
        </div>
        
      </div>
      <div class="start_btn">
          <a href="javascript:;" @click="toGame">去闯关&nbsp;&nbsp;赢赏金</a>
      </div>

      <div class="popup_bg" :class="{show: isPopupShow}" v-if="isPopupShow" @click="close">
          <div class="popup_box">
            <div class="title"><i class="t_tl"></i>赏金挑战<i class="t_tr"></i></div>
            <div class="content">
              <div class="intro" v-html="describe"></div>
              <div class="strategy">
                  <span class="strategy_title">获取高分、高奖励攻略</span>
                  <div class="strategy_txt">
                      <p>1.进入游戏时尽量<font color="#FF7F4B">领取双倍积分</font>(免费)</p><br>
                      <p>2.游戏失败时尽可能<font color="#FF7F4B">点击复活</font>(免费)</p><br>
                      <p>3.游戏结束领取成绩时点击<font color="#FF7F4B">双倍领取</font>(免费)</p><br>
                  </div>
              </div>
            </div>
            <div class="i_konw" @click="close()">我知道了</div>
          </div>
        </div>

      <loading :isLoad="isLoad"></loading>
  </div>
</template>

<style>
  body {
    background: #F5F7FA;
    font-family: PingFangSC-Medium;
  }
</style>

<style scoped>
  .top_blank {
    width: 100%;
    height: 0.3rem;
    background-color: #fff;
  }
  .top {
    height: 0.44rem;
    background-color:#fff;
    font-size: 0.16rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.16rem;
  }
  .top .title {
    width: calc(100% - 1.6rem);
    line-height: 0.44rem;
    text-align: center;
    font-size: 0.18rem;
  }

  .top .back {
    width: 0.8rem;
    height: 0.44rem;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .top .back i {
    width: 0.1rem;
    height: 0.1rem;
    border-left: 2px solid #333;
    border-bottom: 2px solid #333;
    transform: rotate(45deg);
  }
  .top .show_popup {
    width: 0.8rem;
    line-height: 0.44rem;
    text-align: right;
  }


  .header {
    position: relative;
    display: block;
    width: 100%;
    height: 3rem;
    background: url('~@/assets/images/mini_game/header_bg.png') no-repeat;
    background-size: 3.75rem 3rem;
    overflow: hidden;
  }

  .header_step {
    position: absolute;
    top: 0;
    left: 0.08rem;
    width: 3.39rem;
    height: 0.34rem;
    background-image: linear-gradient(to right, #FF7601 , #FF4500);
    border-radius: 0 0 0.08rem 0.08rem;
    padding: 0 0.1rem;
    display: flex;
    justify-content: space-around;
    font-size: 0.14rem;
    color: #fff;
    align-items: center;
  }

  .header_step .header_step_item{
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .header_step .header_step_item span{
    width: 0.14rem;
    height: 0.14rem;
    border-radius: 0.14rem;
    background-color: #fff;
    color:#FF7601;
    font-size: 0.12rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 0.02rem 0 0;
  }
  .game_info {
    margin-top: 0.5rem;
    width: 100%;
  }
  .game_info div {
    display: flex;
    width: 100%;
    justify-content: center;
  }
  .game_icon img {
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 0.06rem;
  }
  .game_info .game_title {
    font-size: 0.24rem;
    color: #fff;
    margin-top: 0.08rem;
    height: 0.33rem;
  }
  .game_info .game_money {
    font-size: 0.12rem;
    color: #fff;
    margin-top: 0.06rem;
    height: 0.17rem;
  }
  .kefu {
    margin: 0.16rem auto 0.16rem auto;
    width: 0.84rem;
    height: 0.3rem;
    line-height: 0.3rem;
    border-radius: 0.15rem;
    border: 0.01rem solid #4A90E2;
    color: #4A90E2;
    font-size: 0.14rem;
    text-align: center;
  }
  .main_box {
    position: relative;
    display: block;
    width: 3.27rem;
    min-height: calc(100vh - 2.26rem);
    padding: 0 0.16rem;
    background: #FFF;
    overflow: hidden;
    border-radius: 0.08rem 0.08rem 0 0;
    margin: -0.72rem auto 0.52rem auto;
  }
  .max_score {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .max_score .max_score_txt{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 2.11rem;
    height: 0.36rem;
    background: url('~@/assets/images/mini_game/score_bg.png') no-repeat;
    background-size: 2.11rem 0.36rem;
    font-size: 0.16rem;
    color: #fff;
  }
  .ranking_title{
    display: flex;
    justify-content: space-between;
    padding: 0 0.16rem;
    height: 0.62rem;
    align-items: center;
    font-size: 0.14rem;
    color: #999;
  }

  .ranking_list {
    display: block;
  }
  .ranking_list .ranging_item {
    height: 0.3rem;
    width: 2.93rem;
    height: 0.6rem;
    border: 0.01rem solid #FF7F4B;
    border-radius: 0.08rem;
    margin-bottom: 0.16rem;
    padding: 0 0.16rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .ranging_item_left{
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .ranging_icon {
    display: flex;
    width: 0.16rem;
    height: 0.15rem;
    background: url('~@/assets/images/mini_game/coin.png') no-repeat;
    background-size: 0.16rem 0.15rem;
    overflow: hidden;
    margin-right: 0.16rem;
  }
  .ranging_score {
    font-size: 0.14rem;
    color:#333;
  }
  .ranging_item_right{
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .ranging_btn {
    font-size: 0.14rem;
    color:#FF7F4B;
    height: 0.3rem;
    line-height: 0.3rem;
  }
  .ranging_add{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-left: 0.12rem;
    min-width: 0.6rem;
    height: 0.3rem;
  }
  .ranging_add_coin{
    font-size: 0.16rem;
    color:#FF7F4B;
  }
  .ranging_add_icon{
    display: flex;
    width: 0.16rem;
    height: 0.16rem;
    background: url('~@/assets/images/money_icon.png') no-repeat;
    background-size: 0.16rem 0.16rem;
    overflow: hidden;
    margin-left: 0.04rem;
  }

  .alreay_receive {
    border: 0.01rem solid #EFEFEF !important;
    background-color: #EFEFEF !important;
  }

  .alreay_receive .ranging_score{
    color:#999 !important;
  }
  .alreay_receive  .ranging_icon {
    background: url('~@/assets/images/mini_game/coin1.png') no-repeat !important;
    background-size: 0.16rem 0.15rem !important;
  }
  .alreay_receive .ranging_btn {
    color:#999 !important;
  }
  .alreay_receive .ranging_add_coin{
    color:#999 !important;
  }
  .receive_btn  .ranging_btn{
    display: flex;
    width: 0.56rem;
    height: 0.24rem;
    background: url('~@/assets/images/mini_game/receive_btn.png') no-repeat !important;
    background-size: 0.56rem 0.24rem !important;
    overflow: hidden;
    justify-content: center;
    align-items: center;
    color:#fff !important;
  }
  .ranging_more {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0.3rem;
    margin-bottom: 0.3rem;
  }
  .ranging_more span {
    padding: 0.07rem 0.21rem;
    color:#FF7F4B;
    font-size: 0.14rem;
    background-color: #FFF0EB;
    border-radius: 0.2rem;
  }
  .start_btn {
    position: fixed;
    bottom: 0;
    display: block;
    padding: 0.06rem 0.16rem;
    background-color: #fff;
  }
  .start_btn a {
    text-decoration: none;
    color: #fff;
    background-image: linear-gradient(to right, #FF7601 , #FF4500);
    font-size: 0.18rem;
    display: -webkit-box;
    display: -ms-flexbox;
    display: block;
    text-align: center;
    height: 0.54rem;
    line-height: 0.54rem;
    border-radius: 0.08rem;
    width: 3.43rem;
  }

  .popup_bg {
    display: none;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 3.75rem;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.75);
    position: fixed;
    z-index: 99;
    top: 0;
  }
  .popup_bg.show {
    display: flex;
  }
  .popup_bg .popup_box {
    display: block;
    width: 3.11rem;
    background-color: #FFF;
    border-radius: 0.08rem;
    overflow: hidden;
    padding: 0.24rem 0.16rem;
    max-height: calc(100vh - 1.8rem);
    overflow-x: hidden;
    overflow-y: auto;
  }
  .popup_bg .popup_box .title {

    font-size: 0.24rem;
    color: #FF7F4B;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .popup_bg .popup_box .title i {
    width: 0.20rem;
    height: 0.06rem;
    overflow: hidden;
  }

  .popup_bg .popup_box .title i.t_tl {
    margin-right: 0.16rem;
    background: url('~@/assets/images/mini_game/tl.png') no-repeat;
    background-size: 0.20rem 0.06rem;
  }
  .popup_bg .popup_box .title i.t_tr {
    margin-left: 0.16rem;
    background: url('~@/assets/images/mini_game/tr.png') no-repeat;
    background-size: 0.20rem 0.06rem;
  }

  .popup_bg .popup_box .content .intro {
    margin: 0 auto;
    margin-top: 0.16rem;
    width: 2.71rem;
    font-size: 0.14rem;
    color:#333;
    margin-bottom: 0.23rem;
    line-height: 0.22rem;
  }

  .popup_bg .popup_box .content .strategy{
    margin: 0 auto;
    margin-top: 0.16rem;
    width: 2.79rem;
    min-height: 1.41rem;
    background-color: #FFF7F2;
    border-radius: 0.06rem;
    padding: 0 0.16rem;
  }
  .popup_bg .popup_box .content .strategy_title{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 1.76rem;
    height: 0.3rem;
    background: url('~@/assets/images/mini_game/score_bg.png') no-repeat;
    background-size: 1.76rem 0.33rem;
    margin-left: 0.52rem;
    font-size: 0.14rem;
    color:#fff;
    margin-bottom: 0.18rem;
  }
  .popup_bg .popup_box .content .strategy_txt{
    color:#333;
    font-size: 0.14rem;
    line-height: 0.14rem;
  }

  .popup_bg .popup_box .i_konw {
    display: block;
    width: 1.7rem;
    height: 0.42rem;
    background-color: #FF7F4B;
    border-radius: 0.08rem;
    font-size: 0.18rem;
    text-align: center;
    line-height: 0.42rem;
    color: #FFF;
    margin: 0 auto;
    margin-top: 0.18rem;
  }

</style>

<script>
import Loading from '@/components/Loading'
import default_icon from '@/assets/images/mini_game/d.png'

export default {
  created() {
    document.title = "赏金挑战";
    this.userid = this.$route.query.userid
    this.activityId = this.$route.query.activity_id

    if (!this.userid) {
      this.userid = this.getCookie('userid')
    }
    if (!this.activityId) {
      this.activityId = this.getCookie('activity_id')
    }

    this.getActivityInfo()
  },
  components: {
    Loading
  },
  data() {
    return {
      userid: '',
      activityId: '',
      gameName: '',
      gameIcon: default_icon,
      gameId: '',
      gameUrl: '',
      gameType: 1,
      describe: '',
      totalCoin: 0,
      receiveCoin: 0,
      integral: 0,
      integralShow: '',
      list:[],
      isPopupShow: false,
      isLoad: false,
      kefu: '',
    }
  },
  methods: {
    getCookie: function (name) {
      var strcookie = document.cookie; //获取cookie字符串
      var arrcookie = strcookie.split("; "); //分割
      //遍历匹配
      for (var i = 0; i < arrcookie.length; i++) {
        var arr = arrcookie[i].split("=");
        if (arr[0] == name) {
          return arr[1];
        }
      }
      return ""
    },
    getClass: function(status) {
      let c = ''
      if (status == 1) {
        c = 'receive_btn'
      }else if (status == 3) {
        c = 'alreay_receive'
      }
      return c;
    },
    // 获取用户活动信息
    getActivityInfo: function () {
      let params = {
        userid: this.userid,
        activity_id: this.activityId
      }

      this.isLoad = true
      this.$http.get('/api/user_web/mini_game_activity_index', {params: params}).then((res) => {
        this.handleReponse(res)
      })
    },
    handleReponse: function (response) {
      let data = response.data
      this.gameName = data.title; // 游戏名称
      this.gameIcon = data.icon; // 游戏图标
      this.gameId = data.game_id
      this.gameUrl = data.game_url
      this.gameType = data.game_typen
      this.describe = data.describe
      this.totalCoin = data.total_reward_coin; // 总奖励
      this.receiveCoin = data.receive_reward_coin; // 已领取
      this.integral = data.my_data.integral;
      this.integralShow = data.my_data.integral_show;
      this.kefu = data.kefu_service.service_id
      this.list = data.list
      this.isLoad = false

      let popupClose = localStorage.getItem('bounty_activity_popup_close' + '_' + this.userid + '_' +  this.activityId)
      if (!popupClose || popupClose != 1) {
        this.isPopupShow = true
      } 

    },
    jumpUrl: function(url) {
      window.location.href = url
    },
    receive: function(status, reward_code) {
      // 领取条件判断 只有待领取的才能操作
      if (status != 1 || !reward_code) {
        return
      }

      let params = {
        userid: this.userid,
        activity_id: this.activityId,
        reward_code: reward_code
      }
      this.isLoad = true
      // http://gametest.lushihudong.com
      this.$http.get('/api/user_web/mini_game_activity_reward', {params: params}).then((res) => {
        this.isLoad = false
        let data = res.data
        if (data.settlement_template) {
          window.injectedObject.setJsContent('show_settlement_template', JSON.stringify(data.settlement_template))
        }
      })
    },
    goBack: function () {
      window.injectedObject.setJsContent('closeWebview', '')
    },
    goKefu () {
      window.injectedObject.setJsContent('qqservice', this.kefu)
    },
    showPopup () {
      // 开启弹窗
      this.isPopupShow = true
    },
    toGame: function () {
      // 开始游戏跳转
      let data = {
        gameMode: this.gameType,
        gameId: this.gameId,
        url: this.gameUrl,
        activityId: this.activityId
      }
      window.injectedObject.setJsContent('start_nanfeng_game', JSON.stringify(data))
    },
    close: function () {
      // 关闭弹窗
      this.isPopupShow = false
      localStorage.setItem('bounty_activity_popup_close' + '_' + this.userid + '_' +  this.activityId, 1)
    }

  }
}
</script>